/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

const workStatuses = [
  { name: "En cours ", value: "IN_PROGRESS" },
  { name: "Déposé ", value: "DEPOSITED" },
  { name: "Délivré ", value: "DELIVERED" }
];
const documentTypes = [
  { name: "Preuve d’engagement", value: "PREUVE_ENGAGEMENT" },
  { name: "Preuve de réalisation", value: "PREUVE_REALISATION" },
  { name: "Attestation sur l’honneur", value: "ATTESTATION_SUR_HONNEUR_AH" },
  { name: "Mandat", value: "MANDAT" },
  { name: "Preuve du RAI", value: "PREUVE_RAI" },
  { name: "Doc technique", value: "DOC_TECHNIQUE" },
  { name: "Autre document", value: "AUTRE_DOCUMENT" }
];
const simulationStatuses = [
  { name: "Estimation en cours", value: "NEW" },
  { name: "Projet estime", value: "CARRIED_OUT" },
  { name: "En cours de preparation", value: "TO_BE_TRANSFORMED" }
];
const SIMULATION_LOST_REASONS = [
  { name: "Travaux non réalisés", value: "TRAVAUX_NON_REALISES" },
  { name: "Affaire perdue", value: "AFFAIRE_PERDUE" },
  { name: "Travaux reportés", value: "TRAVAUX_REPORTES" },
  { name: "CEE valorisé avec la concurrence", value: "CEE_VALORISE_CONCURRENCE" },
  { name: "Travaux non éligible aux CEE", value: "TRAVAUX_NON_ELIGIBLE_CEE" },
  { name: "Travaux fictifs", value: "TRAVAUX_FICTIFS" },
  { name: "Autre : préciser", value: "AUTRE" }
];
const operationStatuses = [
  { name: "Opération créée", value: "OPERATION_CREATED" },
  { name: "Travaux engagée", value: "WORK_ENGAGED" },
  { name: "Travaux terminés", value: "COMPLETED_WORK" },
  { name: "Justificatifs reçus", value: "JUSTIFICATIVE_RECEIVED" },
  { name: "Contrôle COFRAC", value: "COFRAC_CONTROL" },
  { name: "Validée", value: "VALIDATED" },
  { name: "Opération déposée au PNCEE", value: "OPERATION_FILED_TO_PNCEE" },
  { name: "Opération délivrée", value: "OPERATION_DELIVERED" },
  { name: "Opération supprimée", value: "OPERATION_DELETED" },
  { name: "Vérification en cours", value: "VERIFICATION_IN_PROGRESS" },
  { name: "Opération perdue", value: "OPERATION_ABONDONED" },
  {name:  "En attente d'affectation",value:"WAITING_FOR_AFFECTATION"}
];
const lotStatus = [
  { name: "En attente des justificatifs", value: "EN_ATTENTE_JUSTIFICATIFS" },
  { name: "Justificatifs reçus", value: "JUSTIFICATIFS_RECUS" },
  { name: "Validé Administrativement", value: "VALIDE_ADMINISTRATIVEMENT" },
  { name: "Control COFRAC Validé", value: "VALIDE_QUALITE_COFRAC" },
  { name: "Déposé au PNCEE", value: "DEPOSE_PNCEE" },
  { name: "Délivré par le PNCEE", value: "DELIVRE_PNCEE" },
  { name: "CEE sur votre compte", value: "STOCK_COMPTE_CLIENT" },
  { name: "CEE transféré", value: "STOCK_COMPTE_CLIENT_OFEE_LEYTON" },
  { name: "Opérations orphelines", value: "ORPHELIN" }
];
const operationListStatuses = [
  { name: "Estimation Volume", value: "SIMULATION_NEW" },
  { name: "Volume Estimé", value: "SIMULATION_CARRIED_OUT" },
  { name: "En traitement", value: "SIMULATION_TO_BE_TRANSFORMED" },
  { name: "Perdu", value: "SIMULATION_CANCEL" },

  { name: "Opération créée", value: "OPERATION_CREATED" },
  { name: "Travaux engagés", value: "WORK_ENGAGED" },
  { name: "Travaux terminés", value: "COMPLETED_WORK" },
  { name: "Justificatifs reçus", value: "JUSTIFICATIVE_RECEIVED" },
  { name: "Contrôle COFRAC", value: "COFRAC_CONTROL" },
  { name: "Opération Validée", value: "VALIDATED" },
  { name: "En attente d'affectation", value: "WAITING_FOR_AFFECTATION" },
  {name: "Déposée", value: "OPERATION_FILED_TO_PNCEE"},
  {name: "Délivrée", value: "OPERATION_ABONDONED"},
  {name: "Perdue", value: "OPERATION_ABONDONED"},
  {name: "Supprimée", value: "OPERATION_DELETED"},
  {name: "Verification en cours", value: "VERIFICATION_IN_PROGRESS"},
];
const ENTITY_TYPE_OPTION = {
  PROJECT: { name: "Ouvrage", value: "PROJECT" },
  SIMULATION: { name: "Simulation", value: "SIMULATION" }
};
const WORK_CONFIG = {
  fields: [
    {
      element: "intitule",
      name: "Nom de l’ouvrage",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "precarityVolume",
      name: "Volume précaire",
      type: "number",
      entity: "number",
      custom: true
    },
    {
      element: "classicVolume",
      name: "Volume classique",
      type: "number",
      entity: "number",
      custom: true
    },
    {
      element: "numberOflots",
      name: "Nombre de lots",
      type: "number",
      entity: "number",
      custom: true
    },
    {
      element: "numberOfOperations",
      name: "Nombre d’opération(s)",
      type: "number",
      entity: "number",
      custom: true
    },
    {
      element: "status",
      name: "Statut",
      type: "multiselect",
      options: workStatuses,
      entity: "enum",
      custom: false
    }
  ]
};

const DOCUMENT_CONFIG = {
  fields: [
    {
      element: "nomDuDocument",
      name: "Nom du document",
      type: "text",
      entity: "string",
      custom: true
    },
    {
      element: "type",
      name: "Type de document",
      type: "multiselect",
      options: documentTypes,
      entity: "enum",
      custom: true
    },
    {
      element: "creationDate",
      name: "Date de transmission",
      type: "date",
      entity: "date",
      custom: false
    }
  ]
};

const YES_NO_OPTIONS = [
  { name: "Oui", value: true },
  { name: "Non", value: false }
];

const SIMULATION_CONFIG = {
  fields: [
    {
      element: "intitule",
      name: "Nom de la simulation",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "deliveryDate",
      name: "Date de fin prévisionnelle",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "expectedThClassicVolume",
      name: "Volume théorique classique",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "expectedThPrecarityVolume",
      name: "Volume théorique  précaire",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "isDraft",
      name: "Brouillon",
      type: "select",
      entity: "enum",
      options: YES_NO_OPTIONS,
      custom: false
    },
    {
      element: "status",
      name: "Statut",
      type: "multiselect",
      options: simulationStatuses,
      entity: "enum",
      custom: false
    }
  ]
};

const USER_FILTER_OPTION = {
  element: "user",
  name: "Utilisateur attribué",
  type: "select",
  options: [],
  entity: "enum",
  custom: false
};

const AGENCY_FILTER_OPTION = {
  element: "agence",
  name: "Agence",
  type: "select",
  options: [],
  entity: "enum",
  custom: false
};

const OPERATION_CONFIG = {
  fields: [
    {
      element: "institution.address.addressNumber",
      name: "Numéro de rue ou de parcelle",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.addressRoad",
      name: "Voie",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.postalCode",
      name: "Code Postal",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.city",
      name: "Ville",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "beginDate",
      name: "Date d’engagement",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "endDate",
      name: "Date de réalisation",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "operationVolume.classicVolume",
      name: "Volume classique",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "operationVolume.precarityVolume",
      name: "Volume précaire",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "ficheCalcul.fiche.number",
      name: "Fiche CEE",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "installateur.raisonSociale",
      name: "Installateur",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "status",
      name: "Statut",
      type: "multiselect",
      options: operationStatuses,
      entity: "enum",
      custom: true
    }
  ]
};

const SIMULATION_OPERATION_CONFIG = {
  fields: [
    {
      element: "institution.address.addressNumber",
      name: "Numéro de rue ou de parcelle",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.addressRoad",
      name: "Voie",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.postalCode",
      name: "Code Postal",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "institution.address.city",
      name: "Ville",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "beginDate",
      name: "Date d’engagement",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "endDate",
      name: "Date de réalisation",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "operationVolume.classicVolume",
      name: "Volume classique",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "operationVolume.precarityVolume",
      name: "Volume précaire",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "ficheCalcul.fiche.number",
      name: "Fiche CEE",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "installateur.raisonSociale",
      name: "Installateur",
      type: "text",
      entity: "string",
      custom: false
    }
  ]
};

const LOT_CONFIG = {
  fields: [
    {
      element: "id",
      name: "ID",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "status",
      name: "Statut",
      type: "multiselect",
      options: lotStatus,
      entity: "enum",
      custom: true
    }
  ]
};

const USERS_CONFIG = {
  fields: [
    {
      element: "firstName",
      name: "Prénom",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "lastName",
      name: "Nom",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "email",
      name: "Email",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "role.name",
      name: "Role",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "isEnabled",
      name: "Actif",
      type: "select",
      entity: "enum",
      options: YES_NO_OPTIONS,
      custom: false
    }
  ]
};

const AGENCES_CONFIG = {
  fields: [
    {
      element: "raisonSocial",
      name: "Nom de l'agence",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "siret",
      name: "SIRET",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "address",
      name: "Adresse",
      type: "text",
      entity: "string",
      custom: false
    }
  ]
};

const ROLES_CONFIG = {
  fields: [
    {
      element: "name",
      name: "Nom",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "description",
      name: "Description",
      type: "text",
      entity: "string",
      custom: false
    }
  ]
};
export const OPERATIONS_CONFIG = {
  fields: [
    {
      element: "status",
      name: "Statut",
      type: "multiselect",
      options: operationListStatuses,
      entity: "enum",
      custom: true
    },
    {
      element: "intitule",
      name: "Nom d’ouvrage",
      type: "text",
      entity: "string",
      custom: true
    },
    {
      element: "institution.siteName",
      name: "Établissement",
      type: "text",
      entity: "string",
      custom: false
    },
    {
      element: "beginDate",
      name: "Date d’engagement",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "endDate",
      name: "Date de réalisation",
      type: "date",
      entity: "date",
      custom: false
    },
    {
      element: "operationVolume.classicVolume",
      name: "Volume classique",
      type: "number",
      entity: "number",
      custom: false
    },
    {
      element: "operationVolume.precarityVolume",
      name: "Volume précaire",
      type: "number",
      entity: "number",
      custom: false
    },
  ]
};

const DEFAULT_CUSTOM_FILTER = {
  condition: "AND",
  rules: []
};

function setDefaultCustomFilter() {
  return JSON.parse(JSON.stringify(DEFAULT_CUSTOM_FILTER));
}

export const queryConstant = {
  setDefaultCustomFilter,
  WORK_CONFIG,
  SIMULATION_CONFIG,
  DOCUMENT_CONFIG,
  OPERATION_CONFIG,
  SIMULATION_OPERATION_CONFIG,
  LOT_CONFIG,
  USERS_CONFIG,
  AGENCES_CONFIG,
  ROLES_CONFIG,
  AGENCY_FILTER_OPTION,
  USER_FILTER_OPTION,
  YES_NO_OPTIONS,
  SIMULATION_LOST_REASONS,
  OPERATIONS_CONFIG,
  ENTITY_TYPE_OPTION
};
